/* eslint-disable import/no-cycle */
import communicate from 'src/api/communicate';
import toastrError from 'src/helpers/toastr/toastrError';
import Utils from 'src/utils';
import { WTS_MOMENT_DATE_MASK, WTS_MOMENT_SHORT_DATE_MASK } from 'src/constants/dayjs';
import { selectModuleConfiguration } from 'src/store/selectors/configurations';
import { wtsApi } from 'src/api';
import dayjs from 'dayjs';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SAVE_USER_PERIOD_CONFIRMATIONS"] = "SAVE_USER_PERIOD_CONFIRMATIONS";
})(ActionTypes || (ActionTypes = {}));
// eslint-disable-next-line import/no-mutable-exports
export let pendingPeriodConfirmationsRequests = [];
export const saveUserPeriodConfirmations = (confirmations, requestId) => ({ type: ActionTypes.SAVE_USER_PERIOD_CONFIRMATIONS, payload: { confirmations, requestId } });
export function fetchUserConfirmationStatuses(params) {
    return communicate({
        method: 'get',
        url: 'ConfirmationDatas/ConfirmationStatus',
        getParams: Utils.objects.objectToQueryString(params, false)
    });
}
export var RelevantConfirmationApiVersion;
(function (RelevantConfirmationApiVersion) {
    RelevantConfirmationApiVersion[RelevantConfirmationApiVersion["None"] = 0] = "None";
    RelevantConfirmationApiVersion[RelevantConfirmationApiVersion["V1"] = 1] = "V1";
    RelevantConfirmationApiVersion[RelevantConfirmationApiVersion["V2"] = 2] = "V2";
    RelevantConfirmationApiVersion[RelevantConfirmationApiVersion["Both"] = 3] = "Both";
})(RelevantConfirmationApiVersion || (RelevantConfirmationApiVersion = {}));
function getConfirmationApiVersion(requestPeriod, state) {
    const [from, to] = Utils.periods.periodStringToDayjsRange(requestPeriod);
    const mainReportConfig = selectModuleConfiguration(state, 'MainReport');
    const { StartNewMainReportMonth } = mainReportConfig;
    const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
    if (!newReportMigrationMonth)
        return RelevantConfirmationApiVersion.V1;
    if (from.isSameOrAfter(newReportMigrationMonth)) {
        return RelevantConfirmationApiVersion.V2;
    }
    if (to.isBefore(newReportMigrationMonth)) {
        return RelevantConfirmationApiVersion.V1;
    }
    return RelevantConfirmationApiVersion.Both;
}
function getConfirmationsApiV1Payload(params) {
    const { period, departmentIds, userIds } = params;
    const [StartDate, EndDate] = Utils.periods.periodStringToDayjsRange(period);
    return {
        Period: {
            StartDate: StartDate.format(WTS_MOMENT_SHORT_DATE_MASK),
            EndDate: EndDate.format(WTS_MOMENT_SHORT_DATE_MASK)
        },
        UserIds: userIds,
        DepartmentIds: departmentIds
    };
}
function getConfirmationsApiV2Payload(params) {
    const { period, departmentIds, userIds } = params;
    const [StartDate, EndDate] = Utils.periods.periodStringToDayjsRange(period);
    return {
        From: StartDate.format(WTS_MOMENT_DATE_MASK),
        To: Utils.periods.endDateInclusiveToExclusive(EndDate).format(WTS_MOMENT_DATE_MASK),
        UserIds: userIds,
        DepartmentIds: departmentIds,
        PageSize: -1
    };
}
function v2ToV1ConfirmationsAdapter(data, payload) {
    const map = {};
    data.forEach(({ UserId, StartDate, EndDate }) => {
        if (!map[UserId])
            map[UserId] = [];
        map[UserId].push({
            StartDate: dayjs(StartDate).format(WTS_MOMENT_SHORT_DATE_MASK),
            EndDate: dayjs(EndDate).subtract(1, 'day').format(WTS_MOMENT_SHORT_DATE_MASK) // EndDate is exclusive in v2
        });
    });
    payload.UserIds?.forEach((userId) => {
        if (!map[userId])
            map[userId] = [];
    });
    return map;
}
function mergeConfirmationMaps(map1, map2) {
    const result = { ...map1 };
    Object.entries(map2).forEach((entry) => {
        const [userId, periods] = entry;
        if (!result[userId])
            result[userId] = [];
        periods.forEach((period2) => {
            if (!result[userId].some((period1) => period1.StartDate === period2.StartDate)) {
                result[userId].push(period2);
            }
        });
    });
    return result;
}
function getMainReportConfirmations(params, state) {
    const apiVersion = getConfirmationApiVersion(params.period, state);
    if (apiVersion === RelevantConfirmationApiVersion.V1) {
        const payload = getConfirmationsApiV1Payload(params);
        return wtsApi.confirmationDatas.getMainReportConfirmationsCreate(payload)
            .then((response) => response.data.Data);
    }
    else if (apiVersion === RelevantConfirmationApiVersion.V2) {
        const payload = getConfirmationsApiV2Payload(params);
        // @ts-ignore
        return wtsApi.v2.completedWorkConfirmationSearchCreate(payload)
            .then((response) => v2ToV1ConfirmationsAdapter(response.data.Data, payload));
    }
    else if (apiVersion === RelevantConfirmationApiVersion.Both) {
        const payloadV1 = getConfirmationsApiV1Payload(params);
        const payloadV2 = getConfirmationsApiV2Payload(params);
        return Promise.all([
            wtsApi.confirmationDatas.getMainReportConfirmationsCreate(payloadV1)
                .then((response) => response.data.Data),
            // @ts-ignore
            wtsApi.v2.completedWorkConfirmationSearchCreate(payloadV2)
                .then((response) => v2ToV1ConfirmationsAdapter(response.data.Data, payloadV2))
        ]).then(([v1Data, v2Data]) => {
            return mergeConfirmationMaps(v1Data, v2Data);
        });
    }
    else {
        return Promise.reject(new Error('Unsupported API version'));
    }
}
export function loadUserMultiMonthPeriodConfirmations(params) {
    return (dispatch, getState) => {
        const { period, userIds } = params;
        const mainReportConfig = selectModuleConfiguration(getState(), 'MainReport');
        if (!mainReportConfig?.ApprovementRelatedToWorkhours)
            return null;
        const requestId = JSON.stringify(params);
        pendingPeriodConfirmationsRequests = [...pendingPeriodConfirmationsRequests, requestId];
        const confirmationMap = {
            period,
            list: Object.fromEntries(userIds?.map((userId) => [userId, []]) ?? [])
        };
        return getMainReportConfirmations(params, getState())
            .then((list) => {
            confirmationMap.list = list;
            dispatch(saveUserPeriodConfirmations(confirmationMap, requestId));
        })
            .catch((e) => {
            toastrError(e);
            dispatch(saveUserPeriodConfirmations(confirmationMap, requestId));
        })
            .finally(() => {
            pendingPeriodConfirmationsRequests = pendingPeriodConfirmationsRequests.filter((reqId) => reqId !== requestId);
        });
    };
}
